/* eslint-disable react/display-name */
/* eslint-disable jsx-quotes */
import React, { useState, useEffect, useRef, useImperativeHandle, CSSProperties } from "react";
import { Header, Grid, Form, Dimmer, Loader, List, Segment } from "semantic-ui-react"
import moment from "moment"

// Controller
import DashboardController from "react-lib/apps/IsHealth/Dashboard/DashboardController";
import ChatController from "react-lib/apps/IsHealth/Chat/ChatController";
import CardDiagFormHistoryController from "react-lib/apps/IsHealth/Nurse/CardDiagFormHistoryController"
import { prepareForm, QuestionSection, updateThread } from "react-lib/apps/IsHealth/Common/Diag";

import CSS from 'csstype';
import { momentToStringBE } from "react-lib/utils/dateUtils";
import { useIntl } from "react-intl";

interface FormAnalyticsProps {
  apiToken: string;
  division: number;

  //controller
  controller: DashboardController;
  chatController: ChatController;
  diagFormController: CardDiagFormHistoryController;

  onEvent: (args: {
    message: string,
    params: any
  }) => void;

  //List
  patientSegmentList: any[];
  divisionProfileList?: {
    items: any[]
  };
  divisionHasUser: any[],
  diagFormDetail: any;

  isLoadingFormAnalytics: boolean,
}

type Levels = "hig" | "low" | "med" | "nor"

type ColorLevelType = {
  [key in Levels]: CSS.Property.Color
}

const COLOR_LEVEL: ColorLevelType = {
  hig: "red",
  low: "rgb(247 185 0)",
  med: "green",
  nor: "grey"
}

const FormAnalytics = React.forwardRef((props: FormAnalyticsProps, ref) => {
  const intl = useIntl();
  // list
  const [segmentDict, setSegmentDict] = useState(new Map())

  // loading
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingAssessment, setIsLoadingAssessment] = useState(false)

  // selected
  const [selectedKey, setSelectedKey] = useState("")
  const [selectedRow, setSelectedRow] = useState<any>(null)

  // detail
  const [diagFormDetail, setDiagFormDetail] = useState(null)

  const [thread, setThread] = useState<any[]>([]);
  const [isAccessInformation, setIsAccessInformation] = useState(true)

  // Ref
  const isMounted = useRef(false);

  useEffect(() => {
    setIsLoading(true)
    if (props.divisionHasUser[0] && !props.isLoadingFormAnalytics) {
      setSegmentDict(new Map())
      setIsAccessInformation(true)
      setThread([])
      props.onEvent({ message: "GetPatientSegment", params: { divisionHasUser: props.divisionHasUser } })
      props.onEvent({ message: "GetDivisionProfile", params: { division: props.division } })
      isMounted.current = true
    }
  }, [props.divisionHasUser])

  useEffect(() => {
    if (isMounted.current && props.divisionProfileList?.items) {
      setPatientInfo()
    }
  }, [props.patientSegmentList, props.divisionProfileList])

  useEffect(() => {
    // setDiagFormDetail(props.diagFormDetail)
    if (props.diagFormDetail?.id) {
      getPublish(props.diagFormDetail)
    }
  }, [props.diagFormDetail])

  //----  Question
  const getPublish = async (diagFormDetail: any) => {

    let answer = diagFormDetail.answers ? JSON.parse(diagFormDetail.answers) : {};
    let diagRuleId = diagFormDetail.published_diag_rule;

    let [
      response,
      error,
      network
    ] = await props.diagFormController.getPublishedDiagRule({
      apiToken: props.apiToken,
      params: {},
      diagRuleId: diagRuleId ? diagRuleId : null,
    });

    if (response) {
      if (isMounted.current) {
        // setPublishDiagRule(response);

        if (response) {
          let x = prepareForm(response);

          // Combine answer into Question
          for (var key in x) {
            // check if the property/key is defined in the object itself, not in parent
            if (x.hasOwnProperty(key)) {
              if (typeof answer[key] === "boolean") {
                x[key].selected = answer[key] ? true : false;
              } else {
                if (Object.keys(answer).length > 0) {
                  if (answer[key]) {
                    x[key].answer = answer[key].answer;
                    x[key].selected = answer[key].selected;
                    x[key].extra_finished = answer[key].extra_finished;
                  } else {
                    x[key].answer = "";
                    x[key].selected = "";
                    x[key].extra_finished = "";
                  }
                }

                if (
                  answer[key] &&
                  answer[key].extra_items &&
                  x[key] &&
                  x[key].extra_items
                ) {
                  x[key].extra_items.forEach((item: any) => {
                    let z = answer[key].extra_items.find((ans: any) => {
                      return ans.label === item.label;
                    });
                    if (z) {
                      item.value = z.value;
                    }
                  });
                }
              }
            }
          }

          let y = Object.values(x);
          var targetThread = [];
          targetThread = updateThread([], y, y[0]);

          setThread(targetThread);
          setIsLoadingAssessment(false)

        }
      }
    }
  };


  const dummyFunc = () => () => { };
  //---- end Question


  const setPatientInfo = async () => {
    setIsLoading(true)
    const classify = JSON.parse(props.divisionProfileList?.items?.[0]?.extra || '{}')?.classify
    let cloneList: any[] = []
    cloneList = props.patientSegmentList?.map((list) => ({
      ...list,
      data: list.data.sort((a: any, b: any) => ('' + b.form_created_date).localeCompare(a.form_created_date))
    }))

    cloneList.forEach((item: any) => {
      let re = new RegExp(`^${item.result}`)
      segmentDict.set(item.result, {
        data: item.data,
        detail: classify?.find((acc: any) => re.test(acc.triage_level))
      })
    })
    const index = Array.from(segmentDict.keys()).findIndex((key: string) => {
      return segmentDict.get(key)?.detail?.active
    })
    if (index === -1) {
      setIsAccessInformation(false)
    } else {
      setIsAccessInformation(true)
    }
    setSegmentDict(segmentDict)
    setSelectedKey(props.patientSegmentList[index]?.result)
    setIsLoading(false)
  }


  const handleSelectedKey = async (key: string) => {
    // setDiagFormDetail(null)
    setThread([])
    setSelectedKey(key)
  }

  const handleSelectedRow = async (row: any) => {
    // console.log(row.GetDiagFormById)

    setIsLoadingAssessment(true)
    // setDiagFormDetail(null)
    setThread([])
    await props.onEvent({ message: "GetDiagFormById", params: { id: row.diag_form_id } })
    // console.log(res)
    setSelectedRow(row)
  }

  return (
    <div style={{ width: "100%", height: "95vh" }} className="FormAnalytics">
      <Dimmer active={isLoading || props.isLoadingFormAnalytics} inverted>
        <Loader inverted>Loading</Loader>
      </Dimmer>
      <div className="dashboard">
        <Header as="h1">Triage Level</Header>
      </div>
      {/* <Tab
        key === "" ? "(Empty)" : key
        header={["HN", "ชื่อ-นามสกุล", "วันที่คัดกรอง", ""]}
        data={Array.from(segmentDict.keys()).map((key: string) => (
          {
            key: key,
            name: () => (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div
                  className="FormAnalytics triage-level-list" >
                  <label>{key === "" ? "(Empty)" : key}</label>
                  <p></p>
                  <label>{segmentDict.get(key).length}</label>
                </div>
              </div>
            ),
            render: () => (
              <div style={{ height: "100%", overflowY: "scroll" }}>
                {segmentDict.get(key).map((item: any, index: number) => (
                  <div key={index} style={{ display: "flex" }}>
                    <div style={{ flex: 1 }}>{item.division}</div>
                    <div style={{ flex: 1 }}>{item.patient_id}</div>
                    <div style={{ flex: 1 }}>{item.form_updated_date}</div>
                    <div style={{ flex: 1 }}>{item.result}</div>
                  </div>
                ))}
              </div>
            )
          }
        ))}

      /> */}
      <div style={{ display: "flex" }}>
        {
          !isAccessInformation &&
          <div style={{
            position: "absolute",
            left: "31%",
            zIndex: 1,
            top: "18%",
            fontWeight: "bold",
            fontSize: "1em"
          }}>{intl.formatMessage({ id: "ไม่มีสิทธิ์เข้าถึงข้อมูล" })}</div>
        }
        {/* Left item */}
        <div style={{ width: "160px" }}>
          {
            Array.from(segmentDict.keys()).map((key: string) => {
              return segmentDict.get(key)?.detail?.active ? <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                <div
                  className={`triage-level-list${key === selectedKey ? " selected" : ""}`}
                  onClick={() => handleSelectedKey(key)}
                >
                  <label style={{ color: segmentDict.get(key)?.detail?.codeColor, fontSize: "1.2em" }}>{key === "" ? "(Empty)" : segmentDict.get(key)?.detail?.description}</label>
                  <p></p>
                  <label style={{ color: "grey", fontSize: "2em" }}>{segmentDict.get(key).data.length}</label>
                </div>
              </div> : null
            })
          }
        </div>
        <Segment style={{ width: "100%", padding: 0, marginTop: 0, boxShadow: "none", paddingBottom: "14px" }}>


          {/* Header item */}
          <Form className="headers" style={{ borderRadius: "3px", marginBottom: "-14px" }}>
            <Form.Group inline style={{ padding: "8px 30px" }}>
              <Form.Field width={2} style={{ textAlign: "center" }}>
                HN
              </Form.Field>
              <Form.Field width={4} style={{ textAlign: "center" }}>
                ชื่อ-นามสกุล
              </Form.Field>
              <Form.Field width={4} style={{ textAlign: "center" }}>
                วันที่คัดกรอง
              </Form.Field>
              <Form.Field width={6} style={{ textAlign: "center" }}>
                แบบประเมินอาการช่วงกักตัว [Assessment Checklist during Isolation]
              </Form.Field>
            </Form.Group>
          </Form>
          <Grid>
            {/* Center item */}
            <Grid.Column width={9} className="items-list">
              {
                segmentDict.get(selectedKey)?.data?.map((item: any, index: number) =>
                  <>
                    <Form
                      style={{ borderBottom: "1px solid rgb(211 224 225 / 50%)", }}
                      onClick={() => handleSelectedRow(item)}
                      className={selectedRow?.diag_form_id === item.diag_form_id ? "selected" : ""}
                    >
                      <Form.Group inline style={{ padding: "8px 30px", margin: "0" }}>
                        <Form.Field width={4} style={{ fontWeight: "bold" }} className="primary">
                          {item.patient_info?.hn}
                        </Form.Field>
                        <Form.Field width={7} style={{ fontWeight: "bold" }}>
                          {`${item.patient_info?.patient_name}`}
                        </Form.Field>
                        <Form.Field width={6} >
                          {momentToStringBE(moment(item.form_created_date))}
                        </Form.Field>
                      </Form.Group>
                    </Form>
                  </>
                )
              }
            </Grid.Column>
            {/* Right - assessment */}
            <Grid.Column width={7} className="assessment-form">
              <Segment style={{
                height: "100%",
                margin: 0,
                padding: "12px 15px 12px 12px",
                boxShadow: "none",
                border: 0,
                borderRadius: 0,
                backgroundColor: "transparent",
              }}>
                <Dimmer active={isLoadingAssessment} inverted>
                  <Loader inverted>Loading</Loader>
                </Dimmer>
                {thread.length > 0 ? (
                  <QuestionSection
                    threadQuestion={thread}
                    selectedAnswer={dummyFunc}
                    rowsColorAnswer={true}
                  />
                ) : null}
              </Segment>
            </Grid.Column>
          </Grid>

        </Segment>
      </div>



      {/* {props.patientSegmentList.map((item: any, index: number) => (
        <div key={index}>{item.diag_rule}</div>
      ))} */}
    </div>

  );
});


export default React.memo(FormAnalytics);
